/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";

import Select from "react-select";

// kendo react modules ==========================
import "@progress/kendo-theme-material/dist/all.css";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-data-query";

// import demodata =============================
import reservation from "data/SelectEducatorData.json";

import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import * as url from "urlhelpers/UrlHelper";
import { getData, putData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { assetImages } from "constants";

const EducatorSelectionPopup = () => {
  const {
    setReloadReservationList,
    changeReserveEducatorData,
    setChangeReserveEducatorData,
    setSuccess,
    setError,
    setNotificationString,
    screenHeight,
    allowSelectEducator,
  } = useContext(GlobalProvider);

  const token = localStorage.getItem("token");
  const [userList, setUserList] = useState([]); //educator option
  const [responseReceived, setResponseReceived] = useState(false);

  const [showWarning, setShowWarning] = useState(false);
  const [prevEducatorId, setPrevEducatorId] = useState(null);

  const [labelList, setlabelList] = useState([]); // for label list
  const [tagValue, setTagValue] = useState("");
  const [tagData, setTagData] = useState([]);
  const [showEducatorWarning, setShowEducatorWarning] = useState(false);
  const [filterEductor, setFilterEductor] = useState(false);

  const [educatorLoading, setEducatorLoading] = useState(false);

  const { t } = useTranslation(); //for translation
  // without pagination ------------------------------------
  const initialDataState = {};
  const [dataState, setDataState] = useState();
  const [result, setResult] = useState(process(userList, initialDataState));

  const onDataStateChange = (event) => {
    console.log("event -->", event);
    setDataState(event.dataState);
    // Apply sorting
    const sortedData = orderBy(userList, event.dataState.sort);
    setResult(process(sortedData, event.dataState));
  };

  /* function to get all labels */
  const getAllLabels = async () => {
    let requestUrl =
      url.API_BASEURL +
      url.API_GET_ALL_TAG +
      `?token=${token}&isselect=${true}`;

    const response = await getData(requestUrl);

    if (response.status) {
      setlabelList(response.data);
    }
  };

  //function for get all user list
  const getAllEducatorList = async () => {
    setEducatorLoading(true);
    try {
      setShowWarning(false);
      if (changeReserveEducatorData != null) {
        let requestUrl =
          url.API_BASEURL +
          url.GET_ALL_EDUCATOR +
          `?token=${token}&date=${changeReserveEducatorData.startdate}&shift=${changeReserveEducatorData.shift}&starttime=${changeReserveEducatorData.starttime}&endtime=${changeReserveEducatorData.endtime}&activitycode=${changeReserveEducatorData.activitycode}`;

        if (tagData.length > 0) {
          requestUrl += `&tags=${tagData.join(",")}`;
        }

        console.log("req url for educator -->", requestUrl);

        const response = await getData(requestUrl);

        console.log("list of educatros -->", response);

        if (response.status) {
          setUserList(response.data);
          setResponseReceived(true);
          setResult(process(response.data, initialDataState));
        }

        setFilterEductor(false);
      }

      setEducatorLoading(false);
    } catch (error) {
      console.error(error.message);
    }
  };

  // if tagData is not empty then filter the educators else show warning
  const filtereEducators = async () => {
    if (tagData.length == 0) {
      setShowEducatorWarning(true);
      return;
    }

    setFilterEductor(true);
  };

  // Educator 1 Block
  const educatorListblockHTML = (props) => {
    return (
      <td className="educator">
        {/* ----- educator name section start ------ */}
        <p className="d-flex gap-2 align-items-center text-nowrap">
          <span className="d-block icon-user">
            <img
              src={
                props.dataItem.photoimage
                  ? props.dataItem.photoimage.path
                  : assetImages.defaultUser
              }
              alt=""
            />
          </span>
          {props.dataItem.name && props.dataItem.surname ? (
            <span className="d-block">
              {props.dataItem.name} {props.dataItem.surname}
            </span>
          ) : (
            <span className="d-block">{props.dataItem.email}</span>
          )}
        </p>

        {/* ----- educator name section end ------ */}
      </td>
    );
  };

  const customAvailabilityHTML = (props) => {
    return (
      <td className="availability">
        {props.dataItem.availability ? (
          <p className="yes">
            <span className="logged-in">●</span> Yes
          </p>
        ) : (
          <p className="no">
            <span className="logged-out">●</span> No
          </p>
        )}
      </td>
    );
  };

  // const customFieldHTML = () => {
  //   return (
  //     <>
  //       <td className="feedback">
  //         <div className="d-flex align-items-center">
  //           <span className="d-block material-symbols-outlined icon-md icon-fill text-warning">
  //             star
  //           </span>
  //           <span className="d-block material-symbols-outlined icon-md icon-fill text-warning">
  //             star
  //           </span>
  //           <span className="d-block material-symbols-outlined icon-md icon-fill text-warning">
  //             star
  //           </span>
  //           <span className="d-block material-symbols-outlined icon-md">
  //             star
  //           </span>
  //           <span className="d-block material-symbols-outlined icon-md">
  //             star
  //           </span>
  //         </div>
  //       </td>
  //     </>
  //   );
  // };

  //action button html
  const customActionHTML = (props) => {
    return (
      <>
        <td className="action">
          <Link
            to="#"
            className="btn btn-outline-primary btn-sm mw-unset"
            onClick={() => {
              changeEducatorHandler(props.dataItem);
            }}
          >
            {t("Select")}
          </Link>
        </td>
      </>
    );
  };

  //function for change educator
  const changeEducatorHandler = async (educator) => {
    if (changeReserveEducatorData) {
      if (educator.availability) {
        setPrevEducatorId(null);
        setShowWarning(false);
        try {
          let educatorData = {
            preveducator: changeReserveEducatorData.prevEducatore,
            neweducator: educator._id,
            activitycodename: changeReserveEducatorData.activitycodename,
            starttime: changeReserveEducatorData.starttime,
            endtime: changeReserveEducatorData.endtime,
            startdate: changeReserveEducatorData.startdate,
            reserveid: changeReserveEducatorData.reserveid,
          };
          let requestUrl =
            url.API_BASEURL +
            url.API_CHANGE_EDUCATOR +
            `/${changeReserveEducatorData.reserveId}?token=${token}`;
          console.log("Url putdata======>", requestUrl);
          const response = await putData(requestUrl, educatorData);
          console.log("Response change =========>", response);
          if (response.status) {
            let offCanvasPopup = document.querySelector("#selectEducatorPopup");
            let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
            offCanvas.hide();
            setChangeReserveEducatorData(null);
            setReloadReservationList(true);
            getAllEducatorList();
            setSuccess(true);
            setNotificationString(t("Educator selected successfully"));
          }
        } catch (error) {
          console.error(error.message);
          setError(true);
          setNotificationString(
            t("Something went wrong, please try again later")
          );
        }
      } else {
        setShowWarning(true);
        setPrevEducatorId(educator._id);
      }
    }
  };

  //function for change educator again
  const changeEducatorHandlerAfterWarning = async () => {
    if (changeReserveEducatorData && prevEducatorId) {
      setShowWarning(false);
      try {
        let educatorData = {
          preveducator: changeReserveEducatorData.prevEducatore,
          neweducator: prevEducatorId,
          activitycodename: changeReserveEducatorData.activitycodename,
          starttime: changeReserveEducatorData.starttime,
          endtime: changeReserveEducatorData.endtime,
          startdate: changeReserveEducatorData.startdate,
          reserveid: changeReserveEducatorData.reserveid,
        };
        let requestUrl =
          url.API_BASEURL +
          url.API_CHANGE_EDUCATOR +
          `/${changeReserveEducatorData.reserveId}?token=${token}`;
        console.log("Url putdata======>", requestUrl);
        const response = await putData(requestUrl, educatorData);
        console.log("Response change =========>", response);
        if (response.status) {
          let offCanvasPopup = document.querySelector("#selectEducatorPopup");
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();
          setChangeReserveEducatorData(null);
          setReloadReservationList(true);
          getAllEducatorList();
          setPrevEducatorId(null);
          setSuccess(true);
          setNotificationString(t("Educator selected successfully"));
        }
      } catch (error) {
        console.error(error.message);
        setError(true);
        setNotificationString(
          t("Something went wrong, please try again later")
        );
      }
    }
  };

  useEffect(() => {
    if (changeReserveEducatorData) {
      console.log("useEffect to get educators data");
      getAllEducatorList();
      getAllLabels();
    }
  }, [changeReserveEducatorData]);

  useEffect(() => {
    if (filterEductor) {
      getAllEducatorList();
    }
  }, [filterEductor]);

  return (
    <div
      className="offcanvas offcanvas-end border-0"
      tabIndex="-1"
      id="selectEducatorPopup"
      aria-labelledby="selectEducatorPopupLabel"
    >
      <div className="offcanvas-header p-4">
        <h3 className="text-secondary mb-0" id="selectEducatorPopupLabel">
          {allowSelectEducator ? t("Select Educator") : t("Check Availability")}

          {changeReserveEducatorData != null
            ? " " +
              changeReserveEducatorData.startdate +
              "  (" +
              changeReserveEducatorData.starttime +
              " - " +
              changeReserveEducatorData.endtime +
              ")"
            : ""}
        </h3>
        {/* ------- modal close button start ------ */}
        <button
          type="button"
          id="closeCreateMail"
          className="btn-close p-2 bg-white shadow-none shadow-sm m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => {
            setChangeReserveEducatorData(null);

            setResult(process([], initialDataState));

            setShowWarning(false);
            setShowEducatorWarning(false);
          }}
        ></button>
        {/* ------- modal close button end ------ */}
      </div>

      {/* ------ warning section start ------ */}
      {showWarning && (
        <div className="mx-4">
          <div className="alert alert-danger fade show" role="alert">
            <strong>{t("Oops!")}</strong>
            <span className="ms-1">
              {t("Educator is already booked. Are you sure to continue?")}
            </span>
            <button
              className="btn btn-primary ms-3"
              onClick={changeEducatorHandlerAfterWarning}
            >
              {" "}
              {t("Continue Anyway")}
            </button>
          </div>
        </div>
      )}
      {/* ------ warning section end ------ */}

      <div className="offcanvas-body p-4 pt-0">
        {/* filter by labels */}
        <div className="filter-section mb-4 d-flex align-items-center">
          <div style={{ minWidth: "30%" }}>
            <Select
              placeholder={t("Select tag")}
              className="nosearch_select"
              isMulti
              options={labelList}
              value={tagValue}
              onChange={(val) => {
                setTagValue(val);
                setTagData(val.map((label) => label.value));
              }}
            />
          </div>
          <button className="btn btn-primary ml-2" onClick={filtereEducators}>
            {t("Filter")}
          </button>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setTagValue("");
              setTagData([]);
              setFilterEductor(true);
            }}
          >
            {t("Reset")}
          </button>
          {filterEductor && (
            <div className="spinner-border text-secondary ms-2" role="status">
              <span className="sr-only"></span>
            </div>
          )}

          {educatorLoading && (
            <div className="spinner-border text-secondary ms-2" role="status">
              <span className="sr-only"></span>
            </div>
          )}
        </div>
        {/* show educator warning */}
        {showEducatorWarning && (
          <div className="alert alert-danger fade show" role="alert">
            <strong>{t("Oops!")}</strong>
            <span className="ms-1">
              {t("Please select a label to filter educators")}
            </span>
          </div>
        )}

        {/* ------ educator list section start ------ */}
        <div className="table-responsive">
          <Grid
            style={{ minWidth: "100%", height: screenHeight }}
            data={result}
            // filterable={true}
            sortable={true}
            // groupable={true}
            onDataStateChange={onDataStateChange}
            {...dataState}
            //pageable = {true}
            //total = {products.length}
            reorderable
            // resizable
          >
            <GridColumn
              field="name"
              cell={educatorListblockHTML}
              title={t("Educator")}
              width="220px"
            />
            <GridColumn
              field="availability"
              cell={customAvailabilityHTML}
              title={t("Availability")}
              width="200px"
            />
            <GridColumn field="rank" title={t("Rank")} width="200px" />
            <GridColumn
              field="certificate"
              title={t("Certificate")}
              width="200px"
            />
            {allowSelectEducator ? (
              <GridColumn
                cell={customActionHTML}
                title={t("Action")}
                width="200px"
              />
            ) : (
              ""
            )}
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default EducatorSelectionPopup;
